





















import Vue from "vue";
import UserNotificationsList from "@/components/app/global/userNotifications/userNotificationsList.vue";
import { Component, Ref } from "vue-property-decorator";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    UserNotificationsList
  },
  computed: {
    ...mapState({
      hasUnreadNotifications(state, getters) {
        return getters[`data/${DataModules.USER_NOTIFICATIONS}/hasUnread`]();
      }
    })
  }
})
export default class NotificationDropdown extends Vue {
  public loading = false;
  @Ref()
  public readonly userNotificationDropdown!: any;
  @Ref()
  public readonly userNotificationList!: UserNotificationsList;
  public readonly hasUnreadNotifications!: boolean;

  public beforeDestroy() {
    this.$bus.$off("notifications/toggle");
  }

  public mounted() {
    this.$bus.$on("notifications/toggle", this.toggleDropdown);
  }

  public toggleDropdown(isActive) {
    this.$nextTick(() => {
      if (this.userNotificationDropdown.isActive === isActive) {
        return;
      }
      this.userNotificationDropdown.toggle();
    });
  }

  public onScroll(props) {
    if (!this.$refs.userNotificationList) {
      return;
    }
    // @ts-ignore
    this.$refs.userNotificationList.onScroll(props);
  }
}
